import { render, staticRenderFns } from "./global-add.vue?vue&type=template&id=45592009&scoped=true&"
import script from "./global-add.vue?vue&type=script&lang=ts&"
export * from "./global-add.vue?vue&type=script&lang=ts&"
import style0 from "./global-add.vue?vue&type=style&index=0&id=45592009&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45592009",
  null
  
)

export default component.exports